export const computePinDiff = (
	prev: string[],
	next: string[]
): { added: string[]; removed: string[] } => {
	const prevSet = new Set(prev);
	const nextSet = new Set(next);
	return {
		added: Array.from(nextSet).filter((id) => !prevSet.has(id)),
		removed: Array.from(prevSet).filter((id) => !nextSet.has(id)),
	};
};
